import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Map from './Map';
import source from '../../assets/source.json';
import bg1 from '../../assets/images/b1.png';


export default class ThemedWalk extends Component {
    constructor(props) {
        super(props);

        const allThemes = source.themes;
        // const shuffledTags = allTags.sort(() => 0.5 - Math.random());
        // const selectedTags = shuffledTags.slice(0, 3);

        this.state = {
            themes: allThemes
        };
    }

    componentDidMount() {

    }

    setTheme(theme) {
        this.setState({ selectedTheme: theme.tags });
    }

    renderTags() {
        return (
            <div>
                <div className="pageHeader" style={{ backgroundImage: `url(${bg1})` }}>
                    <h1>Themed Walk</h1>
                </div>
                <h2>Pick a Theme</h2>
                <p>Each of the poems in A Poetry Mile fits into a variety of themes that lend themselves to the specific kind of thinking that seems to happen while you’re on a walk. Every time you reload this page, three new themes will pop up, so in the off-chance you’re not exactly into what’s come up below, you can hit the refresh button till you’re satisfied.</p>
                {this.state.themes.map((theme) => {
                    return <Row>
                        <span className="button button-themed" onClick={() => this.setTheme(theme)}>{theme.title}</span>
    
                    </Row>
                })}
            </div>
        );
    }

    renderMap() {
        return (
            <div>
                <div className="pageHeader" style={{ backgroundImage: `url(${bg1})` }}>
                    <h1>Themed Walk</h1>
                </div>
                <Map selectedTheme={this.state.selectedTheme} themedWalk={true} />
            </div>
        );
    }

    render() {
        if (this.state.selectedTheme) return this.renderMap();
        return this.renderTags();
    }
}
